/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DefinitionDto } from './DefinitionDto';
import {
    DefinitionDtoFromJSON,
    DefinitionDtoFromJSONTyped,
    DefinitionDtoToJSON,
} from './DefinitionDto';
import type { NumericEvaluationParameterDto } from './NumericEvaluationParameterDto';
import {
    NumericEvaluationParameterDtoFromJSON,
    NumericEvaluationParameterDtoFromJSONTyped,
    NumericEvaluationParameterDtoToJSON,
} from './NumericEvaluationParameterDto';

/**
 * 
 * @export
 * @interface NumericEvaluationParameterTemplateDto
 */
export interface NumericEvaluationParameterTemplateDto {
    /**
     * 
     * @type {NumericEvaluationParameterDto}
     * @memberof NumericEvaluationParameterTemplateDto
     */
    numericEvaluationParameter?: NumericEvaluationParameterDto;
    /**
     * 
     * @type {Array<DefinitionDto>}
     * @memberof NumericEvaluationParameterTemplateDto
     */
    availableDefinitions?: Array<DefinitionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof NumericEvaluationParameterTemplateDto
     */
    $type?: NumericEvaluationParameterTemplateDtoTypeEnum;
}


/**
 * @export
 */
export const NumericEvaluationParameterTemplateDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersNumericEvaluationParameterTemplateDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.NumericEvaluationParameterTemplateDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericEvaluationParameterTemplateDtoTypeEnum = typeof NumericEvaluationParameterTemplateDtoTypeEnum[keyof typeof NumericEvaluationParameterTemplateDtoTypeEnum];


/**
 * Check if a given object implements the NumericEvaluationParameterTemplateDto interface.
 */
export function instanceOfNumericEvaluationParameterTemplateDto(value?: unknown): value is NumericEvaluationParameterTemplateDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericEvaluationParameterTemplateDtoTypeEnum)[0];
}

export function NumericEvaluationParameterTemplateDtoFromJSON(json: any): NumericEvaluationParameterTemplateDto {
    return NumericEvaluationParameterTemplateDtoFromJSONTyped(json, false);
}

export function NumericEvaluationParameterTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericEvaluationParameterTemplateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'numericEvaluationParameter': !exists(json, 'numericEvaluationParameter') ? undefined : NumericEvaluationParameterDtoFromJSON(json['numericEvaluationParameter']),
        'availableDefinitions': !exists(json, 'availableDefinitions') ? undefined : (json['availableDefinitions'] === null ? null : (json['availableDefinitions'] as Array<any>).map(DefinitionDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericEvaluationParameterTemplateDtoToJSON(value?: NumericEvaluationParameterTemplateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'numericEvaluationParameter': NumericEvaluationParameterDtoToJSON(value.numericEvaluationParameter),
        'availableDefinitions': value.availableDefinitions === undefined ? undefined : (value.availableDefinitions === null ? null : (value.availableDefinitions as Array<any>).map(DefinitionDtoToJSON)),
        '$type': value.$type,
    });
}

